module.exports = __webpack_public_path__ + "static/img/customer-code.2426b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customer-code.png
// module id = lQto
// module chunks = 1